import { useRef, useEffect } from "react";
import usePrintDocument from "../usePrintDocument";
import "./PdfRceStyle.scss";
import moment from "moment/moment";
import QrCode from "../../qrCode/QrCode";
function PdfRce({ reciboData, showPreviousPage, paperSize = "A4" }) {
  const componentRef = useRef();

  const handlePrint = usePrintDocument({
    contentRef: componentRef,
    documentTitle: `Fatura-${reciboData.cliente.nome}_${moment(
      new Date(),
    ).format("DD-MM-YYYY")}`,
    onAfterPrint: () => {
      showPreviousPage();
    },
    pageStyle:
      paperSize === "A5"
        ? "@page { size: A5 portrait; }"
        : "@page { size: A4 portrait; }",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  return (
    <>
      <div
        ref={componentRef}
        className={`pdf-rce-wrapper ${reciboData.clinica?.configuracoes?.configuracoes?.impressaoPretoEBranco?.ativo ? " pdf-wrapper--pretoebranco" : ""} ${paperSize === "A5" ? "a5-size" : ""}`}
      >
        <div className="pdf-orcamento-cabecalho" id="pdf-rce-cabecalho">
          <div className="pdf-orcamento-cabecalho-left">
            <img
              src={`${process.env.REACT_APP_BACKEND_LINK}/${reciboData.clinica.logotipo}`}
              alt=""
            />
          </div>

          <div className="pdf-orcamento-cabecalho-right pdf-rce-cabecalho-right">
            <span>{reciboData.clinica.nome}</span>
            {reciboData.medico_responsavel && (
              <span>
                {reciboData.medico_responsavel.genero === "masculino"
                  ? "Dr. "
                  : "Dra. "}
                {reciboData.medico_responsavel.name}/
                {reciboData.medico_responsavel.profissao}
              </span>
            )}
            <span>
              Telef: {reciboData.clinica.contacto}
              {reciboData.clinica.contacto2
                ? "/" + reciboData.clinica.contacto2
                : ""}
              {reciboData.clinica.contacto3
                ? "/" + reciboData.clinica.contacto3
                : ""}
            </span>
            <span>{reciboData.clinica.endereco}</span>
            <span>NIF: {reciboData.clinica.nif}</span>
          </div>
        </div>

        <div className="pdf-rce-cabecalho2">
          <div className="pdf-rce__infoCliente">
            <div>
              <span>Cliente: </span>
              <span className="blackText">{reciboData.cliente.nome}</span>
            </div>

            <div>
              <span>Morada: </span>
              <span className="blackText">{reciboData.cliente.endereco}</span>
            </div>

            <div>
              <span>Contacto: </span>
              <span className="blackText">{reciboData.cliente.contacto}</span>
            </div>

            {reciboData.cliente.nif && (
              <div>
                <span>NIF: </span>
                <span className="blackText">{reciboData.cliente.nif}</span>
              </div>
            )}
          </div>
        </div>

        <div className="pdf-rce-cabecalho3">
          <div className="pdf-rce__reciboData">
            <div>
              <span>Documento: </span>
              <span className="blackText">
                {reciboData.tipoDocumento +
                  "/" +
                  moment(reciboData.dataDocumento).year() +
                  "/" +
                  reciboData.serie +
                  "/" +
                  reciboData.nrDocumento}
              </span>
            </div>
            <div>
              <span>Data: </span>
              <span className="blackText">
                {moment(reciboData.dataDocumento).format("DD/MM/YYYY")}
              </span>
            </div>
          </div>
        </div>

        <div className="divFaturaTabela">
          <table>
            <tbody>
              <tr className="headingLineFatura">
                <th>Referência</th>
                <th>Nº Doc Interno</th>
                <th className="right-td">Montante Pago</th>
              </tr>
              <tr className="normalLine primeiraLinha">
                <td>{reciboData.referencia.replace(/\.xml$/, "")}</td>
                <td>{reciboData.nrDocumento}</td>
                <td className="right-td">
                  {reciboData.valor.toLocaleString("pt-br")}
                </td>
              </tr>
            </tbody>
          </table>
          {reciboData.emitidoEmContingencia && (
            <div className="emitidoEmContingencia__mensagem__container">
              <p>EMITIDO EM CONTINGÊNCIA OFFLINE</p>
              <p>Pendente de Autorização</p>
            </div>
          )}
        </div>

        <div className="pdf-rce-rodape">
          <hr />
          <div className="pdf-rce-rodape__container">
            <div className="pdf-rce-rodape__container2">
              <span className="pdf-rce-rodape__container2__titulo">
                Informações de Pagamento:
              </span>
              <span>Data Pagamento</span>
              <span className="pdf-rce-rodape__container2__item--dark">
                {moment(reciboData.dataPagamento).format("DD/MM/YYYY")}
              </span>
              <span>Meio Pagamento</span>
              <span className="pdf-rce-rodape__container2__item--dark">
                {reciboData.metodoPagamento}
              </span>
              <span>Total</span>
              <span className="pdf-rce-rodape__container2__item--dark">
                {reciboData.valor.toLocaleString("pt-br")}$00
              </span>
            </div>

            <div className="pdf-rce-rodape__container1">
              {!reciboData.emitidoEmContingencia && (
                <QrCode
                  link={reciboData.entryName.replace(/\.xml$/, "")}
                  estilo={{ alignItems: "flex-end" }}
                />
              )}
            </div>
          </div>
          <div
            className={`pdf-rce-rodape__elaboradoPor ${
              reciboData.usuarioEmissor
                ? ""
                : "pdf-rce-rodape__elaboradoPor--semEmissor"
            }`}
          >
            <span>Elaborado Por</span>
            {reciboData.usuarioEmissor ? (
              <span className="pdf-rce-rodape__elaboradoPor__emissor">
                {reciboData.usuarioEmissor
                  .trim()
                  .split(" ")
                  .filter(Boolean)
                  .reduce(
                    (acc, part, _, arr) =>
                      acc.length ? acc : [arr[0], arr[arr.length - 1]],
                    [],
                  )
                  .join(" ") +
                  " - " +
                  moment(reciboData.dataDocumento).format("DD/MM/YYYY")}
              </span>
            ) : (
              <hr />
            )}
          </div>
          {reciboData.emitidoEmContingencia && (
            <div className="pdf-fatura-rodape__contingenciaInfo">
              Este documento não confere direito a dedução de imposto, enquanto
              o documento associado não for transmitido e autorizado pela
              Administração Fiscal.
            </div>
          )}
          <div className="pdf-rce-rodape__poweredBy">
            Powered by: HealthTech CV
          </div>
        </div>
      </div>
    </>
  );
}

export default PdfRce;
